export const FETCH_BRANDING_TEMPLATES_REQUEST = 'FETCH_BRANDING_TEMPLATES_REQUEST';
export const FETCH_BRANDING_TEMPLATES_SUCCESS = 'FETCH_BRANDING_TEMPLATES_SUCCESS';
export const FETCH_BRANDING_TEMPLATES_FAILURE = 'FETCH_BRANDING_TEMPLATES_FAILURE';
